import { render, staticRenderFns } from "./BudgetSpent.vue?vue&type=template&id=39215f90"
import script from "./BudgetSpent.vue?vue&type=script&lang=js"
export * from "./BudgetSpent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports